@if (careUnit$ | async; as careUnit) {
  @if (careUnitLogos.indexOf(careUnit?.careUnitLogo) !== -1) {
    <img
      src="/content/logos/ks/{{ careUnit.careUnitLogo }}"
      alt="{{ careUnitLogoAltTexts[careUnitLogos.indexOf(careUnit.careUnitLogo)] }}" />
  } @else {
    <div class="d-flex align-items-center">
      <wfs-wf-logo></wfs-wf-logo>
      <h1 class="px-3 my-0">Webbformulär</h1>
    </div>
  }
}
